import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { DataTable } from 'primeng/primeng';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { Campaign, CampaignPersistType } from "../../models/inModels/campaign";
import { CampaignService } from "../../services/campaign.service";

@Component({
	selector: 'app-campaigns',
	templateUrl: './campaigns.component.html',
	styleUrls: ['./campaigns.component.css']
})
export class CampaignsComponent {
	items: Campaign[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	campaignPersistType = CampaignPersistType;
	constructor(
		private service: CampaignService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: any) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(item: Campaign) {
		this.router.navigate(['campaigns/edit', item.Id]);
	}


	delete(item: Campaign) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this Campaign?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(item.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/campaigns/campaigns.component.ts